<template>
  <div class="education">
    <van-collapse v-model="activeNames">
      <van-collapse-item title="教育经历" :name="1">
        <van-collapse-item
          class="conTitle"
          v-for="(item, ind) in euBgeducationList"
          :name="'1' + ind"
          :title="item.school"
          :key="item.id"
        >
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.empno"
              label="员工工号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.begindate"
              label="开始时间"
              :readonly="item.readonly"
              v-if="item.readonly === true"
            />
            <van-field
              input-align="right"
              label-width="100"
              type="date"
              v-model="item.begindate"
              label="开始时间"
              v-else
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.enddate"
              label="结束时间"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.school"
              label="学校"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.major"
              label="专业"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.studytype"
              label="学习形式"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.education"
              label="学历"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.degree"
              label="学位"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="160"
              v-model="item.eduattech"
              label="学历证书附件(图片)"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="160"
              v-model="item.degatteach"
              label="学位证书附件(图片)"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.remark"
              label="备注"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <!-- <van-button round class="btn" @click="ducationRead(item.id)" v-if="item.readonly===true"><van-icon name="edit" style="margin-right:6px" />修改</van-button>
            <van-button round class="btnTwo" @click="ducationReset(item.id)" v-if="item.readonly===false">取消</van-button>
            <van-button round class="btnTwo" type="info" @click="ducationQuery(item.id)" v-if="item.readonly===false">确定</van-button> -->
        </van-collapse-item>
        <!-- <van-button class="btnThree" @click="$router.push('/addEducation')"><van-icon name="add-o" style="margin-right: 6px;" />添加</van-button> -->
      </van-collapse-item>
      <van-collapse-item title="语言能力" :name="2">
        <van-collapse-item
          class="conTitle"
          v-for="(item, ind) in euBglanguagesList"
          :title="item.language"
          :name="'2' + ind"
          :key="item.id"
        >
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.empno"
              label="员工工号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.language"
              label="语言"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.grade"
              label="等级"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.certificate"
              label="证书"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.certorg"
              label="附件"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="120"
              v-model="item.getdate"
              label="证书获取日期"
              :readonly="item.readonly"
              v-if="item.readonly === true"
            />
            <van-field
              input-align="right"
              type="date"
              label-width="120"
              v-model="item.getdate"
              label="证书获取日期"
              v-else
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.remark"
              label="备注"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.files"
              label="附件(图片)"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <!-- <div class="edit">
            <van-button
              round
              class="btn"
              @click="languagesRead(item.id)"
              v-if="item.readonly === true"
              ><van-icon
                name="edit"
                style="margin-right: 6px"
              />修改</van-button
            >
          </div> -->
          <!-- <div class="add">
            <van-button
              round
              class="btnTwo"
              @click="languagesReset(item.id)"
              v-if="item.readonly === false"
              >取消</van-button
            >
            <van-button
              round
              class="btnTwo"
              type="info"
              @click="languagesQuery(item.id)"
              v-if="item.readonly === false"
              >确定</van-button
            >
          </div> -->
        </van-collapse-item>
        <!-- <van-button class="btnThree" @click="$router.push('/addLanguages')"
          ><van-icon name="add-o" style="margin-right: 6px" />添加</van-button
        > -->
      </van-collapse-item>
      <van-collapse-item title="奖惩经历" :name="3">
        <van-collapse-item
          class="conTitle"
          v-for="(item, ind) in euBgrewardList"
          :title="item.rewardtype"
          :name="'3' + ind"
          :key="item.id"
        >
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.empno"
              label="员工工号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              v-if="item.readonly === true"
              label-width="100"
              v-model="item.rewardtype"
              label="奖惩类型"
              :readonly="item.readonly"
            />
            <van-field
              input-align="right"
              v-else
              readonly
              clickable
              label-width="100"
              :value="item.rewardtype"
              label="奖惩类型"
              @click="(showRewardtype = true), getDict('rewardtype')"
            />
            <van-popup v-model="showRewardtype" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConRewardtype"
                @cancel="showRewardtype = false"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.rewardname"
              label="奖惩名称"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.rewarddate"
              label="奖惩时间"
              :readonly="item.readonly"
              v-if="item.readonly === true"
            />
            <van-field
              input-align="right"
              label-width="100"
              type="date"
              v-model="item.rewarddate"
              label="奖惩时间"
              v-else
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.rewardorg"
              label="组织"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="120"
              v-model="item.rewardreason"
              label="原因"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.rewardcontent"
              label="描述"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.remark"
              label="备注"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <!-- <div class="edit">
            <van-button
              round
              class="btn"
              @click="rewardRead(item.id)"
              v-if="item.readonly === true"
              ><van-icon
                name="edit"
                style="margin-right: 6px"
              />修改</van-button
            >
          </div>
          <div class="add">
            <van-button
              round
              class="btnTwo"
              @click="rewardReset(item.id)"
              v-if="item.readonly === false"
              >取消</van-button
            >
            <van-button
              round
              class="btnTwo"
              type="info"
              @click="rewardQuery(item.id)"
              v-if="item.readonly === false"
              >确定</van-button
            >
          </div> -->
        </van-collapse-item>
        <!-- <van-button class="btnThree" @click="$router.push('/addReward')"
          ><van-icon name="add-o" style="margin-right: 6px" />添加</van-button
        > -->
      </van-collapse-item>
      <van-collapse-item title="职业资格" :name="4">
        <van-collapse-item
          class="conTitle"
          v-for="(item, ind) in euBgtitleList"
          :title="item.titlename"
          :name="'4' + ind"
          :key="item.id"
        >
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.empno"
              label="员工工号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              v-if="item.readonly === true"
              label-width="100"
              v-model="item.titletype"
              label="职称类型"
              :readonly="item.readonly"
            />
            <van-field
              input-align="right"
              v-else
              readonly
              clickable
              label-width="100"
              :value="item.titletype"
              label="职称类型"
              @click="(showTitletype = true), getDict('titletype')"
            />
            <van-popup v-model="showTitletype" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConTitletype"
                @cancel="showTitletype = false"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              v-if="item.readonly === true"
              label-width="100"
              v-model="item.titlegrade"
              label="等级"
              :readonly="item.readonly"
            />
            <van-field
              input-align="right"
              v-else
              readonly
              clickable
              label-width="100"
              :value="item.titlegrade"
              label="等级"
              @click="(showTitlegrade = true), getDict('titlegrade')"
            />
            <van-popup v-model="showTitlegrade" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConTitlegrade"
                @cancel="showTitlegrade = false"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.titlename"
              label="职业资格名称"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.titlegettype"
              label="职称取得途径"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="120"
              v-model="item.titlegetdate"
              label="获得日期"
              :readonly="item.readonly"
              v-if="item.readonly === true"
            />
            <van-field
              input-align="right"
              label-width="120"
              type="date"
              v-model="item.titlegetdate"
              label="获得日期"
              v-else
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.titleno"
              label="编号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.files"
              label="附件(图片)"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.remark"
              label="备注"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <!-- <div class="edit">
            <van-button
              round
              class="btn"
              @click="titleRead(item.id)"
              v-if="item.readonly === true"
              ><van-icon
                name="edit"
                style="margin-right: 6px"
              />修改</van-button
            >
          </div>
          <div class="add">
            <van-button
              round
              class="btnTwo"
              @click="titleReset(item.id)"
              v-if="item.readonly === false"
              >取消</van-button
            >
            <van-button
              round
              class="btnTwo"
              type="info"
              @click="titleQuery(item.id)"
              v-if="item.readonly === false"
              >确定</van-button
            >
          </div> -->
        </van-collapse-item>
        <!-- <van-button class="btnThree" @click="$router.push('/addTitle')"
          ><van-icon name="add-o" style="margin-right: 6px" />添加</van-button
        > -->
      </van-collapse-item>
      <van-collapse-item title="专业技术资格" :name="5">
        <van-collapse-item
          class="conTitle"
          v-for="(item, ind) in euBgprocertList"
          :title="item.certname"
          :name="'5' + ind"
          :key="item.id"
        >
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.empno"
              label="员工工号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              v-if="item.readonly === true"
              label-width="100"
              v-model="item.procerttype"
              label="专业认证类型"
              :readonly="item.readonly"
            />
            <van-field
              input-align="right"
              v-else
              readonly
              clickable
              label-width="100"
              :value="item.procerttype"
              label="专业认证类型"
              @click="(showProcerttype = true), getDict('procerttype')"
            />
            <van-popup v-model="showProcerttype" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConProcerttype"
                @cancel="showProcerttype = false"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="140"
              v-model="item.certname"
              label="专业技术资质名称"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.certename"
              label="证书英文名"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.certgetdate"
              label="获得日期"
              :readonly="item.readonly"
              v-if="item.readonly"
            />
            <van-field
              input-align="right"
              label-width="100"
              type="date"
              v-model="item.certgetdate"
              label="获得日期"
              v-else
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="120"
              v-model="item.certno"
              label="编号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.certgrade"
              label="等级"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.files"
              label="附件(图片)"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.remark"
              label="备注"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <!-- <div class="edit">
            <van-button
              round
              class="btn"
              @click="procertRead(item.id)"
              v-if="item.readonly === true"
              ><van-icon
                name="edit"
                style="margin-right: 6px"
              />修改</van-button
            >
          </div>
          <div>
            <van-button
              round
              class="btnTwo"
              @click="procertReset(item.id)"
              v-if="item.readonly === false"
              >取消</van-button
            >
            <van-button
              round
              class="btnTwo"
              type="info"
              @click="procertQuery(item.id)"
              v-if="item.readonly === false"
              >确定</van-button
            >
          </div> -->
        </van-collapse-item>
        <!-- <van-button class="btnThree" @click="$router.push('/addProcert')"
          ><van-icon name="add-o" style="margin-right: 6px" />添加</van-button
        > -->
      </van-collapse-item>
      <van-collapse-item title="培训经历" :name="6">
        <van-collapse-item
          class="conTitle"
          v-for="(item, ind) in euBgtrainingList"
          :title="item.subject"
          :name="'6' + ind"
          :key="item.id"
        >
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.empno"
              label="员工工号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.type"
              label="课程类型"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="140"
              v-model="item.subject"
              label="课程名称"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.begindate"
              label="参与时间"
              :readonly="item.readonly"
              v-if="item.readonly === true"
            />
            <van-field
              input-align="right"
              label-width="100"
              type="date"
              v-model="item.begindate"
              @change="setTrainingState"
              label="参与时间"
              v-else
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.enddate"
              label="结束时间"
              :readonly="item.readonly"
              v-if="item.readonly === true"
            />
            <van-field
              input-align="right"
              label-width="100"
              type="date"
              v-model="item.enddate"
              @change="setTrainingEnd"
              label="结束时间"
              v-else
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="120"
              v-model="item.address"
              label="培训地点"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.hours"
              label="课程时长"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.certname"
              label="所获证书"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.certno"
              label="证书编号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.organizer"
              label="主办单位"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.teacher"
              label="授课讲师"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.development"
              label="开展形式"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.traintype"
              label="培训类型"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.trainmoney"
              label="培训费用"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.trainagreement"
              label="培训协议"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.score"
              label="考试成绩"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.credit"
              label="所获学分"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              type="textarea"
              :autosize="{ maxHeight: 50, minHeight: 20 }"
              rows="1"
              input-align="right"
              label-width="100"
              v-model="item.remark"
              label="备注"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <!-- <div class="edit">
            <van-button
              round
              class="btn"
              @click="trainingRead(item.id)"
              v-if="item.readonly === true"
              ><van-icon
                name="edit"
                style="margin-right: 6px"
              />修改</van-button
            >
          </div>
          <div class="add">
            <van-button
              round
              class="btnTwo"
              @click="trainingReset(item.id)"
              v-if="item.readonly === false"
              >取消</van-button
            >
            <van-button
              round
              class="btnTwo"
              type="info"
              @click="trainingQuery(item.id)"
              v-if="item.readonly === false"
              >确定</van-button
            >
          </div> -->
        </van-collapse-item>
        <!-- <van-button class="btnThree" @click="$router.push('/addTraining')"
          ><van-icon name="add-o" style="margin-right: 6px" />添加</van-button
        > -->
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis";
import utils from "@/utils/utils";
import { getToken } from "@/utils/cookie";
export default {
  name: "education",
  props: ["toFrom"],
  data() {
    return {
      tagList: [],
      activeNames: [],
      showRewardtype: false,
      showTitlegrade: false,
      showTitletype: false,
      showProcerttype: false,
      //教育经历
      euBgeducationList: [],
      //语言能力
      euBglanguagesList: [],
      //奖惩经历
      euBgrewardList: [],
      euBgrewardListData: [],
      //职业资格
      euBgtitleList: [],
      euBgtitleListData: [],
      //专业技术资格
      euBgprocertList: [],
      euBgprocertListData: [],
      //培训经历
      euBgtrainingList: [],
      euBgtrainingListData: {},
      columns: [],
      itemId: [],
      id: {
        idRewardtype: "",
        idTitlegrade: "",
        idTitletype: "",
        idProcerttype: "",
      },
      diffData: {},
    };
  },
  mounted() {
    this.getList();
    const type = this.$route.query.type;
    setTimeout(() => {
      if (this.toFrom.name === "addLanguages" && type === "add") {
        const lang = this.euBglanguagesList.length - 1;
        this.activeNames = [2, "2" + lang];
      } else if (this.toFrom.name === "addReward" && type === "add") {
        const lang = this.euBgrewardList.length - 1;
        this.activeNames = [3, "3" + lang];
      } else if (this.toFrom.name === "addTitle" && type === "add") {
        const lang = this.euBgtitleList.length - 1;
        this.activeNames = [4, "4" + lang];
      } else if (this.toFrom.name === "addProcert" && type === "add") {
        const lang = this.euBgprocertList.length - 1;
        this.activeNames = [5, "5" + lang];
      } else if (this.toFrom.name === "addTraining" && type === "add") {
        const lang = this.euBgtrainingList.length - 1;
        this.activeNames = [6, "6" + lang];
      } else if (this.toFrom.name === "addLanguages" && type === "no") {
        this.activeNames = [2, "20"];
      } else if (this.toFrom.name === "addReward" && type === "no") {
        this.activeNames = [3, "30"];
      } else if (this.toFrom.name === "addTitle" && type === "no") {
        this.activeNames = [4, "40"];
      } else if (this.toFrom.name === "addProcert" && type === "no") {
        this.activeNames = [5, "50"];
      } else if (this.toFrom.name === "addTraining" && type === "no") {
        this.activeNames = [6, "60"];
      } else {
        this.activeNames = [1, "10"];
      }
    }, 1000);
  },
  methods: {
    //获取下拉框数据
    getDict(type) {
      api.setGetDicts({ type }).then((data) => {
        this.itemId = data.data;
        let items = data.data;
        this.columns = [];
        items.forEach((item) => {
          this.columns.push(item.title);
        });
      });
    },
    //选择奖惩类型
    onConRewardtype(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idRewardtype = str.id;
      this.euBgrewardList.forEach((item) => {
        item.rewardtype = value;
      });
      this.showRewardtype = false;
    },
    //选择等级
    onConTitlegrade(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idTitlegrade = str.id;
      this.euBgtitleList.forEach((item) => {
        item.titlegrade = value;
      });
      this.showTitlegrade = false;
    },
    //选择职称类型
    onConTitletype(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idTitletype = str.id;
      this.euBgtitleList.forEach((item) => {
        item.titletype = value;
      });
      this.showTitletype = false;
    },
    //选择专业认证类型
    onConProcerttype(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idProcerttype = str.id;
      this.euBgprocertList.forEach((item) => {
        item.procerttype = value;
      });
      this.showProcerttype = false;
    },
    saveList(obj) {
      api.setSaveEmpInfo(obj).then(() => {
        this.getList();
      });
    },
    // ducationRead(id){
    //   const index = this.euBgeducationList.find((item) => {
    //     return item.id === id;
    //   });
    //   index.readonly = false;
    // },
    // ducationReset(id){
    //   const index = this.euBgeducationList.find((item) => {
    //     return item.id === id;
    //   });
    //   index.readonly = true;
    //   this.getList()
    // },
    // ducationQuery(id){
    //   const index = this.euBgeducationList.find((item) => {
    //     return item.id === id;
    //   });
    //   index.readonly = true;
    //   let obj = {
    //     ...index,
    //     table:'euBgeducationList',
    //     type:'2',
    //     readonly:true,
    //     id:index.id,
    //     empno:index.empno,
    //     empid:index.empid
    //   }
    //   this.saveList(obj)
    // },
    //点击修改
    languagesRead(id) {
      const index = this.euBglanguagesList.find((item) => {
        return item.id === id;
      });
      index.readonly = false;
    },
    //点击取消
    languagesReset(id) {
      const index = this.euBglanguagesList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      this.getList();
    },
    //点击确定
    languagesQuery(id) {
      const index = this.euBglanguagesList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      let obj = {
        ...index,
        table: "euBglanguagesList",
        saveType: "2",
        readonly: true,
        id: index.id,
        empno: index.empno,
        empid: index.empid,
      };
      this.saveList(obj);
    },
    //点击修改
    rewardRead(id) {
      const index = this.euBgrewardList.find((item) => {
        return item.id === id;
      });
      index.readonly = false;
      this.euBgrewardListData = { ...index };
    },
    //点击取消
    rewardReset(id) {
      const index = this.euBgrewardList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      this.getList();
    },
    //点击确定
    rewardQuery(id) {
      const index = this.euBgrewardList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      utils.getDiffData(this.euBgrewardListData, index, this.diffData);
      if (this.id.idRewardtype) this.diffData.rewardtype = this.id.idRewardtype;
      let obj = {
        ...this.diffData,
        table: "euBgrewardList",
        saveType: "2",
        readonly: true,
        id: index.id,
        empno: index.empno,
        empid: index.empid,
      };
      this.saveList(obj);
      this.diffData = {};
    },
    //点击修改
    titleRead(id) {
      const index = this.euBgtitleList.find((item) => {
        return item.id === id;
      });
      index.readonly = false;
      this.euBgtitleListData = { ...index };
    },
    //点击取消
    titleReset(id) {
      const index = this.euBgtitleList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      this.getList();
    },
    //点击确定
    titleQuery(id) {
      const index = this.euBgtitleList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      utils.getDiffData(this.euBgtitleListData, index, this.diffData);
      if (this.id.idTitlegrade) this.diffData.titlegrade = this.id.idTitlegrade;
      if (this.id.idTitletype) this.diffData.titletype = this.id.idTitletype;
      let obj = {
        ...this.diffData,
        table: "euBgtitleList",
        saveType: "2",
        readonly: true,
        id: index.id,
        empno: index.empno,
        empid: index.empid,
      };
      this.saveList(obj);
      this.diffData = {};
    },
    //点击修改
    procertRead(id) {
      const index = this.euBgprocertList.find((item) => {
        return item.id === id;
      });
      index.readonly = false;
      this.euBgprocertListData = { ...index };
    },
    //点击取消
    procertReset(id) {
      const index = this.euBgprocertList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      this.getList();
    },
    //点击确定
    procertQuery(id) {
      const index = this.euBgprocertList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      utils.getDiffData(this.euBgprocertListData, index, this.diffData);
      if (this.id.idProcerttype)
        this.diffData.procerttype = this.id.idProcerttype;
      let obj = {
        ...this.diffData,
        table: "euBgprocertList",
        saveType: "2",
        readonly: true,
        id: index.id,
        empno: index.empno,
        empid: index.empid,
      };
      this.saveList(obj);
      this.diffData = {};
    },
    //点击修改
    trainingRead(id) {
      const index = this.euBgtrainingList.find((item) => {
        return item.id === id;
      });
      index.readonly = false;
      this.euBgtrainingListData = index;
    },
    //点击取消
    trainingReset(id) {
      const index = this.euBgtrainingList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      this.getList();
    },
    //点击确定
    trainingQuery(id) {
      const index = this.euBgtrainingList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      let obj = {
        ...index,
        table: "euBgtrainingList",
        saveType: "2",
        readonly: true,
        id: index.id,
        empno: index.empno,
        empid: index.empid,
      };
      this.saveList(obj);
    },
    //获取数据列表
    getList() {
      api.getSelectByEmpNo({ empNo: getToken() }).then((data) => {
        this.tagList = data.data;
        console.log(this.tagList, "22222");
        this.euBgeducationList = this.tagList.euBgeducationList;
        this.euBglanguagesList = this.tagList.euBglanguagesList;
        this.euBgrewardList = this.tagList.euBgrewardList;
        this.euBgtitleList = this.tagList.euBgtitleList;
        this.euBgprocertList = this.tagList.euBgprocertList;
        this.euBgtrainingList = this.tagList.euBgtrainingList;

        this.euBgeducationList.forEach((item) => {
          item.begindate =
            item.begindate && moment(item.begindate).format("YYYY-MM-DD");
          item.enddate =
            item.enddate && moment(item.enddate).format("YYYY-MM-DD");
        });
        this.euBglanguagesList.forEach((item) => {
          item.getdate =
            item.getdate && moment(item.getdate).format("YYYY-MM-DD");
        });
        this.euBgrewardList.forEach((item) => {
          item.rewarddate =
            item.rewarddate && moment(item.rewarddate).format("YYYY-MM-DD");
        });
        this.euBgtitleList.forEach((item) => {
          item.titlegetdate =
            item.titlegetdate && moment(item.titlegetdate).format("YYYY-MM-DD");
        });
        this.euBgprocertList.forEach((item) => {
          item.certgetdate =
            item.certgetdate && moment(item.certgetdate).format("YYYY-MM-DD");
        });
        this.euBgtrainingList.forEach((item) => {
          item.begindate =
            item.begindate && moment(item.begindate).format("YYYY-MM-DD");
          item.enddate =
            item.enddate && moment(item.enddate).format("YYYY-MM-DD");
        });
      });
    },
    //参与时间不能大于结束时间
    setTrainingState() {
      if (
        this.euBgtrainingListData.begindate >
          this.euBgtrainingListData.enddate &&
        this.euBgtrainingListData.enddate
      ) {
        this.$toast("参与时间不能大于结束时间");
        this.euBgtrainingListData.begindate = "";
      }
    },
    //结束时间不能小于开始时间
    setTrainingEnd() {
      if (
        this.euBgtrainingListData.enddate < this.euBgtrainingListData.begindate
      ) {
        this.$toast("结束时间不能小于开始时间");
        this.euBgtrainingListData.enddate = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.education {
  ::v-deep .van-picker__toolbar {
    height: 40px * $zoom;
    .van-picker__cancel {
      font-size: 0.42667rem;
    }
    .van-picker__confirm {
      font-size: 16px * $zoom;
    }
  }
  ::v-deep .van-ellipsis {
    font-size: 8px * $zoom;
  }
  .van-collapse-item {
    margin-top: 5px * $zoom;
    background: none;
  }
  ::v-deep .van-cell__title span {
    font-size: 12px * $zoom;
    border-left: 6px solid #018755;
    padding-left: 15px;
  }
  ::v-deep .van-field {
    span {
      font-size: 10px * $zoom;
      border: none;
      padding-left: 0;
    }
  }
  ::v-deep .van-cell {
    display: flex;
    justify-content: space-between;
    border-radius: 15px;
  }
  ::v-deep .van-collapse-item__content {
    background: none;
    padding: 5px 0 0 0;
  }
  .conTitle {
    background: #fff;
    border-radius: 2px * $zoom;
    ::v-deep .van-cell__title span {
      font-size: 10px * $zoom;
      border: none;
      padding-left: 0;
    }
  }
}
.edit {
  width: 100%;
  display: flex;
  justify-content: center;
}
.btn {
  font-size: 12pt;
  padding: 10px * $zoom 40px * $zoom;
  margin: 10px * $zoom 0;
}
.add {
  width: 100%;
  display: flex;
  justify-content: center;
  .van-button__content {
    width: 80pt;
  }
}
.btnTwo {
  font-size: 12pt;
  // padding: 20px * $zoom 50px * $zoom;
  margin: 10px * $zoom 0 10px * $zoom 10px * $zoom;
}
.btnThree {
  margin-top: 10px * $zoom;
  font-size: 14pt;
  width: 100%;
  height: 40px * $zoom;
}
</style>
